import { useLogger } from "amazon-chime-sdk-component-library-react";
import { useDevices } from "../../../providers/DevicesProvider";
import DeviceInput from "../DeviceInput";
import { useBrowserCompatibilityFeatures } from "@platform/features/video/hooks/useBrowserCompatibilityFeatures";

interface Props {
  /** The message that will be shown when no microphone devices are found. */
  notFoundMsg?: string;
  /** The label that will be shown for microphone selection, it defaults to `Microphone source`. */
  label?: string;
}

export const MicSelection: React.FC<React.PropsWithChildren<Props>> = ({
  notFoundMsg = "No microphone devices found",
  label = "Microphone source",
  ...rest
}) => {
  const logger = useLogger();
  const {
    audioInputDevices,
    selectedAudioInputDevice,
    selectAudioInputDevice,
  } = useDevices();

  const { supportsAudio } = useBrowserCompatibilityFeatures();

  const handleSelect = async (deviceId: string): Promise<void> => {
    try {
      await selectAudioInputDevice(deviceId);
      console.log('Selected audio input device on join page:', deviceId);
    } catch (error) {
      logger.error("MicSelection failed to select mic");
    }
  };

  return (
    <DeviceInput
      name="mic-selection"
      label={label}
      onChange={handleSelect}
      devices={audioInputDevices}
      selectedDevice={selectedAudioInputDevice}
      notFoundMsg={notFoundMsg}
      disabled={!supportsAudio}
      {...rest}
    />
  );
};

export default MicSelection;
